import { propsWithContextMergeHelper } from 'helpers/propsWithContextMergeHelper'
import React from 'react'

const contextConnectorV2 = (Context) => (
  may_be_alias,
  options = {},
) => {

  return (ComposedComponent) =>
    class extends React.Component {
      render () {

        return (
          <Context.Consumer>
            {(context) => {
              return (
                <ComposedComponent
                  {...propsWithContextMergeHelper(this.props, context, may_be_alias, options)}
                />
              )
            }}
          </Context.Consumer>
        )
      }

      displayName = 'contextConnector'
    }

}
contextConnectorV2.displayName = 'contextConnector'
export default contextConnectorV2
